module.exports = class BrowseErrorPresenter
  toHash: ->
    href = window.location.href
    aOpen = "<a href='#{href}'>"
    aClose = "</a>"
    breakline = "<br>"
    queryParams = Groupon.Utils.unparam()
    #TODO: experiment check
    isPriceFilterSelected = queryParams?.minPrice? or queryParams?.maxPrice?
    isClearanceSelected = queryParams?.discount == "gg-clearance"
    if isPriceFilterSelected
      category = queryParams?.category or 'all'
      href = "/goods?category=#{category}"
      aOpen = "<a href='#{href}'>"
      error_message_header: I18n.translate 'js.modules.browse.presenters.error_message.message_header'
      error_message_content_p1: I18n.translate 'js.modules.browse.presenters.error_message.price_range_message_content_p1', { aOpen, aClose }
      error_message_content_p2: I18n.translate 'js.modules.browse.presenters.error_message.message_content_p2', { breakline }
    else if isClearanceSelected
      href = "/goods?category=all&discount=gg-clearance"
      aOpen = "<a href='#{href}'>"
      error_message_header: I18n.translate 'js.modules.browse.presenters.error_message.message_header'
      error_message_content_p1: I18n.translate 'js.modules.browse.presenters.error_message.clearance_message_content_p1', { aOpen, aClose }
    else
      error_message_header: I18n.translate 'js.modules.browse.presenters.error_message.message_header'
      error_message_content_p1: I18n.translate 'js.modules.browse.presenters.error_message.message_content_p1', { aOpen, aClose }
      error_message_content_p2: I18n.translate 'js.modules.browse.presenters.error_message.message_content_p2', { breakline }
